import { render, staticRenderFns } from "./SelectCustomerSizes.vue?vue&type=template&id=7c8b07f8"
import script from "./SelectCustomerSizes.vue?vue&type=script&lang=js"
export * from "./SelectCustomerSizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports